export const HOURS_MIN = 7
export const HOURS_MAX = 19
export const clampHour = v => Math.min(HOURS_MAX, Math.max(HOURS_MIN, Number(v)))
export const toNum = v => (v === '' || v == null ? 0 : Number(v))
export const isHour = v => Number.isInteger(v) && v >= HOURS_MIN && v <= HOURS_MAX
export const phoneRegex = /^[0-9()+\-.\s]*$/
export const numericInputRegex = /^(?:[0-9]\d*)?$/
export const MIN_PHONE_DIGITS = 8
export const MAX_PHONE_DIGITS = 24
export const DAY_OPTIONS = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday']

export function hourToLocalizedLabel(
  hour,
  {
    locale = typeof navigator !== 'undefined' ? navigator.language : 'en-US',
    timeZone = 'UTC',
  } = {}
) {
  // Build a stable “fake” date at the chosen hour.
  // Use UTC so the numeric hour doesn’t drift across time zones.
  // Render with desired timeZone if one is passed.
  const d = new Date(`2000-01-01T${String(hour).padStart(2, '0')}:00:00Z`)

  const formatter = new Intl.DateTimeFormat(locale, {
    hour: 'numeric',
    minute: 'numeric',
    hour12: true,
    timeZone,
  })
  return formatter.format(d)
}

export const regionSubsidiaryIds = {
  UKE: '24_25_26', // UK, IE, NL
  AUS: '21', // AU
  NZ: '22', // NZ
}

export const getSubsidiaryIdsForRegion = region => regionSubsidiaryIds[region] || null
